import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import Modal from 'react-modal';
import { mediumModalStyle, mediumSmModalStyle } from '../../constants';
import { FaFileExcelO } from 'react-icons/lib/fa';
import { withAuth } from '../../actions/';
import { MdPayment, MdImportExport, MdAttachMoney, MdDescription, MdAssignment, MdList, MdFontDownload } from 'react-icons/lib/md';
import { fetchProjectContractDetails } from '../../actions/additional_actions';
import CSBContractDetails from './CSBContractDetails';
import ChangeOrders from './ChangeOrders';
import PaymentDetails from './PaymentDetails';
import FundingSources from './FundingSources';
import ContractManagementDetails from './ContractManagementDetails';
import TaskOrderDetail from './TaskOrderDetail';
import { getDateValue } from '../../utils/date';
import { formatMoney } from '../../utils/budget';
import AccoFlowDetails from './AccoFlowDetails';
import ReactTooltip from 'react-tooltip'
import {INITIATE_TO_URL} from '../../actions/index'; 

class ProjectContractDetailsNew extends Component {

    // static PropTypes = {
    //     projectId: PropTypes.string.isRequired,
    //     contracts: PropTypes.array.isRequired,
    // }

	constructor(props) {
		super(props);
       
		this.state = {
			contract: {},
			accordata: [],
			registered: [],
			regContracts: [],
			paymentmodalVisible: false,
			comodalVisible: false,
			contractDetailsVisible: false, 
			AccomodalVisible: false,  
			FSVisible: false,         
			TOVisible: false,
			CMDVisible: false,
			desClass: true
		}

		this.handleExportToExcel = this.handleExportToExcel.bind(this);
		this.initiateTaskOrder = this.initiateTaskOrder.bind(this);
		this.handleTOExportToExcel = this.handleTOExportToExcel.bind(this);
		this.handleCOExportToExcel = this.handleCOExportToExcel.bind(this);
		this.handlePaymentExportToExcel = this.handlePaymentExportToExcel.bind(this);
		this.showPayments = this.showPayments.bind(this);
		this.showChangeOrders = this.showChangeOrders.bind(this);
		this.showFundingSources = this.showFundingSources.bind(this);
		this.showContractDetails = this.showContractDetails.bind(this);
		this.showTaskOrders = this.showTaskOrders.bind(this);
		this.showCMDetails = this.showCMDetails.bind(this);
		this.showAccoDetails = this.showAccoDetails.bind(this);
		this.onDone = this.onDone.bind(this);
		this.changeclass = this.changeclass.bind(this);
	}


	UNSAFE_componentWillMount() {
		this.props.fetchProjectContractDetails(this.props.projectId);       
	}
    
	onDone(e) {
  

        //e.stopPropagation();

		this.setState({  
			paymentmodalVisible: false,
			comodalVisible: false, 
			contractDetailsVisible: false,   
			AccomodalVisible: false,
			FSVisible: false,         
			TOVisible: false,
			CMDVisible: false  });

	}
    
	showPayments(contract) {
		this.setState({ paymentmodalVisible: true, contract: contract });
	}
    
	showAccoDetails(contract){
		this.setState({ AccomodalVisible: true, contract: contract });
	}
    
	showChangeOrders(contract){
		this.setState({ comodalVisible: true, contract: contract });
	}
    
	showFundingSources(contract){
		this.setState({ FSVisible: true, contract: contract });
	}

	showContractDetails(contract){
		this.setState({ contractDetailsVisible: true, contract: contract });
	}
    
	showTaskOrders(contract){
		this.setState({ TOVisible: true, contract: contract });
	}
    
	showCMDetails(contract){
		this.setState({ CMDVisible: true, contract: contract });
	}

	changeclass(){
		this.setState({ desClass: !this.state.desClass });
	}

	handleExportToExcel() {
		const projectId = this.props.projectId;

		let url = `projects/${projectId}/ExportContractsList`;
		let method = 'post';
		let responseType = 'arraybuffer';

		withAuth(
            { method, url, responseType },
            (response) => {
	var data = response.data;
	var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
	var blob = new Blob([data], { type: contentType });
	var downloadUrl = window.URL.createObjectURL(blob);
	var link = document.createElement('a');
	link.href = downloadUrl;
	link.download = 'ContractLists.xlsx';
	link.click();
},
            this.errorHandler
        )
	}
	
    initiateTaskOrder(){
		const projectId = this.props.projectId;
		let url = INITIATE_TO_URL + projectId;
		window.open(url,'_blank');
	}

	handlePaymentExportToExcel() {
        
        // pass project Id 

		const projectId = this.state.contract.projectId;
		const cntrctId = this.state.contract.contractId;
            
		let url = `projects/${projectId}/ExportPaymentDetails/${cntrctId}`;
		let method = 'post'; 
		let responseType = 'arraybuffer';
    
		withAuth(
               { method, url, responseType },
               (response) => {
	var data = response.data;
	var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
	var blob = new Blob([data], { type: contentType }); 
	var downloadUrl= window.URL.createObjectURL(blob);
	var link = document.createElement('a');
	link.href = downloadUrl;
	link.download='PaymentDetails.xlsx';
	link.click();
},
               this.errorHandler
             )
	}
	handleCOExportToExcel() {
        
        // pass project Id 

		const projectId = this.state.contract.projectId;
		const cntrctId = this.state.contract.contractId;
            
		let url = `projects/${projectId}/ExportChangeOrders/${cntrctId}`;
		let method = 'post'; 
		let responseType = 'arraybuffer';
    
		withAuth(
               { method, url, responseType },
               (response) => {
	var data = response.data;
	var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
	var blob = new Blob([data], { type: contentType }); 
	var downloadUrl= window.URL.createObjectURL(blob);
	var link = document.createElement('a');
	link.href = downloadUrl;
	link.download='ChangeOrders.xlsx';
	link.click();
},
               this.errorHandler
             )
	}

	handleTOExportToExcel() {
        
        // pass project Id 

		const projectId = this.state.contract.projectId;
		const cntrctId = this.state.contract.contractId;
        
		let url = `projects/${projectId}/ExportTaskOrders/${cntrctId}`;
		let method = 'post'; 
		let responseType = 'arraybuffer';

		withAuth(
        { method, url, responseType },
        (response) => {
	var data = response.data;
	var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
	var blob = new Blob([data], { type: contentType }); 
	var downloadUrl= window.URL.createObjectURL(blob);
	var link = document.createElement('a');
	link.href = downloadUrl;
	link.download='TaskOrders.xlsx';
	link.click();
},
        this.errorHandler
        )
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (this.props.contracts !== nextProps.contracts){
			if (nextProps.contracts.length > 0) {
				if (nextProps.contracts[0].divisionName === 'Infrastructure') {
					let newVal = _.filter(nextProps.contracts, (doc) => (doc.regNumber != null));
					this.setState({ registered: newVal });
				} else {
					let newVal = _.filter(nextProps.contracts, (doc) => (doc.regNumber != null && !doc.contractType.includes('Force Account/')));
					this.setState({ registered: newVal });
				}
			}
		}
	}

	render() {
		const { contract } = this.state;
        //const { contracts } = this.props;
        
        // let desClass = "";
        
        // if (this.state.desClass === true) 
        //     desClass ="description";
        // else desClass ="description-open";

        // if (contracts.length > 0) {
        //     if (contracts[0].divisionName === 'Infrastructure') {
        //         let newVal = _.filter(contracts, (doc) => (doc.regNumber != null));
        //         this.setState({ registered: newVal });
        //     } else {
        //         let newVal = _.filter(contracts, (doc) => (doc.regNumber != null && !doc.contractType.includes('Force Account/')));
        //         this.setState({ registered: newVal });
        //     }
        // }

		return (
           
            <div id="blueBook" className="row-wide">
                {this.state.paymentmodalVisible
                    && <Modal
                        isOpen={this.state.paymentmodalVisible}
                        style={mediumModalStyle}
                        contentLabel="Payment Details"
                    >      
                      <div className='contr-det-modal-div'><p><strong>Contract Type:</strong> {contract.contractType} </p>
                        <p><strong>Registration #: </strong>{contract.regNumber}</p>
                        <p><strong>Pin #: </strong>{contract.pinNumber}</p>
                       </div>
                       <h1 className="bar-bottom header margin-bottom-175">
                       <button className="btn-save btn-excel float-right margin-top--5" onClick={() => this.handlePaymentExportToExce()}>
                        <span className="margin-right-05"> <FaFileExcelO size={18} color='#008000' /></span>
                        Excel</button> 
                        <span className='margin-right-0325' id='greyColor'><MdPayment className="fa-Icon" size={20} /></span>
                        Payment Details</h1>
                        <div className="modal-form contractmodal">
                            <div className="project-detail-comments">
                                <div className="col s12">
                                    <PaymentDetails contract={contract} />
                                </div>
                            </div>
                        </div>

                        <div className="modal-close" onClick={this.onDone}>
                            <span className="close"></span>
                        </div>
                    </Modal>
                }
                {this.state.comodalVisible
                    && <Modal
                        isOpen={this.state.comodalVisible}
                        style={mediumModalStyle}
                        contentLabel="Change Order Details"
                    >    

                       <div className='contr-det-modal-div'><p><strong>Contract Type:</strong> {contract.contractType} </p>
                        <p><strong>Registration #: </strong>{contract.regNumber}</p>
                        <p><strong>Pin #: </strong>{contract.pinNumber}</p>
                       </div>
                       <h1 className="bar-bottom header margin-bottom-175">
                       <button className="btn-save btn-excel float-right margin-top--5" onClick={() => this.handlePaymentExportToExce()}>
                        <span className="margin-right-05"> <FaFileExcelO size={18} color='#008000' /></span>
                        Excel</button>   
                        <span className='margin-right-0325' id='greyColor'><MdImportExport className="fa-Icon" size={20} /></span>
                        Change Order Details</h1>
                        <div className="modal-form contractmodal">
                            <div className="project-detail-comments">
                                <div className="col s12">
                                <ChangeOrders contract={contract} />
                                </div>
                            </div>
                        </div>                       

                        <div className="modal-close" onClick={this.onDone}>
                            <span className="close"></span>
                        </div>
                    </Modal>
                }  

                {this.state.AccomodalVisible
                    && <Modal
                        isOpen={this.state.AccomodalVisible}
                        style={mediumSmModalStyle}
                        contentLabel="Acco Flow Details">

                    <div className='contr-det-modal-div'><p><strong>Contract Type:</strong> {contract.contractType} </p>
                        <p><strong>Registration #: </strong>{contract.regNumber}</p>
                        <p><strong>Pin #: </strong>{contract.pinNumber}</p>
                    </div>

                    <h1 className="bar-bottom header margin-bottom-175">
                        <span className='margin-right-0325' id='greyColor'><MdFontDownload className="fa-Icon" size={20} /></span>
                        Acco Flow Details</h1>
                        
                        <div className="modal-form">
                            <AccoFlowDetails contract={contract} />
                        </div>

                        <div className="modal-close" onClick={this.onDone}>
                            <span className="close"></span>
                        </div>
                    </Modal>
                }

                {this.state.contractDetailsVisible
                    && <Modal
                        isOpen={this.state.contractDetailsVisible}
                        style={mediumModalStyle}
                        contentLabel="Contract Details"
                    >    
                     <div className='contr-det-modal-div'><p><strong>Contract Type:</strong> {contract.contractType} </p>
                        <p><strong>Registration #: </strong>{contract.regNumber}</p>
                        <p><strong>Pin #: </strong>{contract.pinNumber}</p>
                       </div>
                        <div className="modal-form contractmodal">
                            <div className="project-detail-comments">
                                <div className="col s12">
                                    <CSBContractDetails contract={contract} />
                                </div>
                            </div>
                        </div>
                        <div className="modal-close" onClick={this.onDone}>
                            <span className="close"></span>
                        </div>
                    </Modal>
                }

                 {this.state.FSVisible
                    && <Modal
                        isOpen={this.state.FSVisible}
                        style={mediumModalStyle}
                        contentLabel="Funding Source Details"
                    >      
                      <div className='contr-det-modal-div'><p><strong>Contract Type:</strong> {contract.contractType} </p>
                        <p><strong>Registration #: </strong>{contract.regNumber}</p>
                        <p><strong>Pin #: </strong>{contract.pinNumber}</p>
                       </div>
                       <h1 className="bar-bottom header margin-bottom-175">
                        <span className='margin-right-0325' id='greyColor'><MdAttachMoney className="fa-Icon" size={20} /></span>
                        Funding Source Details</h1>
                        <div className="modal-form contractmodal">
                            <div className="project-detail-comments">
                                <div className="col s12">
                                    <FundingSources contract={contract} />
                                </div>
                            </div>
                        </div>
                        <div className="modal-close" onClick={this.onDone}>
                            <span className="close"></span>
                        </div>
                    </Modal>
                }
                
                {this.state.TOVisible
                    && <Modal
                        isOpen={this.state.TOVisible}
                        style={mediumModalStyle}
                        contentLabel="Task Order Details"
                    >      
                        <div className='contr-det-modal-div'><p><strong>Contract Type:</strong> {contract.contractType} </p>
                        <p><strong>Registration #: </strong>{contract.regNumber}</p>
                        <p><strong>Pin #: </strong>{contract.pinNumber}</p>
                       </div>
                       <h1 className="bar-bottom header margin-bottom-175">
                       <button className="btn-save btn-excel float-right margin-top--5" onClick={() => this.handlePaymentExportToExce()}>
                        <span className="margin-right-05"> <FaFileExcelO size={18} color='#008000' /></span>
                        Excel</button>   
                        <span className='margin-right-0325' id='greyColor'><MdAssignment className="fa-Icon" size={20} /></span>
                        Task Order Details</h1>
                        <div className="modal-form contractmodal">
                            <div className="project-detail-comments">
                                <div className="col s12">
                                    <TaskOrderDetail contract={contract} />
                                </div>
                            </div>
                        </div>
                        <div className="modal-close" onClick={this.onDone}>
                            <span className="close"></span>
                        </div>
                    </Modal>
                }

                  {this.state.CMDVisible
                    && <Modal
                        isOpen={this.state.CMDVisible}
                        style={mediumModalStyle}
                        contentLabel="Contract Management Details"
                        shouldCloseOnOverlayClick={true}
                    >      
                          <div className='contr-det-modal-div'><p><strong>Contract Type:</strong> {contract.contractType} </p>
                        <p><strong>Registration #: </strong>{contract.regNumber}</p>
                        <p><strong>Pin #: </strong>{contract.pinNumber}</p>
                       </div>
                       <div className="modal-form contractmodal">
                            <div className="project-detail-comments">
                                <div className="col s12 cmd">
                                    <ContractManagementDetails contract={contract} />
                                </div>
                            </div>
                        </div>
                        <div className="modal-close" onClick={this.onDone}>
                            <span className="close"></span>
                        </div>
                    </Modal>
                }

                <div className="col s12">
                    <button className="btn-save float-right margin-top-035" onClick={() => this.initiateTaskOrder()}>
                        <span className="margin-right-05"> <MdAssignment className="fa-Icon" size={18} /> </span>
                        Initiate Task Order</button>

                    {this.state.registered.length > 0 && this.state.registered !== null
                        ? <button className="btn-save btn-excel float-right margin-top-035" onClick={() => this.handlePaymentExportToExce()}>
                            <span className="margin-right-05"> <FaFileExcelO size={18} color='#008000' /></span>
                            Excel</button>
                        : null}
                    <h4 className="bar-bottom">Contract Details </h4>
                </div>

                        {this.state.registered.length > 0 && this.state.registered !== null ?
                    <div>
                        {this.state.registered.map((co, index) =>
                            <div key={index} className="container">
                                <div className="row">
                                    <div className="col s12">
                                        <div className="card" id="contract-card">

                                            <div className="card-left">
                                                
                                                <div className="categories"> {co.contractType} </div>
                                                {(!co.contractType.includes('Construction/') 
                                                && !co.contractType.includes('Force Account/')) ?  
                                                <h4 className="padding-top-0 padding-bottom-0">{co.contractDescription} - Parent/Base</h4> 
                                                :  <h4 className="padding-top-0 padding-bottom-0">{co.contractDescription}</h4>}
                                               
                                                <p><strong>Pin #:</strong>{co.pinNumber}</p>
                                                <p className="fmsids"><strong>Registration #:</strong>{co.regNumber}</p>
                                                <p><strong>Contract Status:</strong>{co.contractStatus}</p>
                                                <p><strong>Procurement Status:</strong>{co.procurementStatus}</p>
                                                <p><strong>Vendor:</strong>{co.contractor}</p>

                                                <div className="row card-details"></div>
                                                <p><strong>Estimated Cost:</strong>{formatMoney(co.estimatedFinalCost)}</p>
                                                <p><strong>Current Award:</strong>{formatMoney(co.currentContractAmount)}</p>
                                                <p><strong>Current Registr. Amount:</strong>{formatMoney(co.current_Registered_Amount)}</p>

                                                <div>
                                                    <div id="blueColor"><strong id="greyColor">Actions:</strong>                                                       
                                                        <span className="detailsicon" data-tip="View Acco Flow Details" onClick={() => this.showAccoDetails(co)}><ReactTooltip /><MdFontDownload className="fa-Icon" size={20} /></span>                                                       
                                                        <span className="detailsicon" data-tip="View Payments" onClick={() => this.showPayments(co)}><ReactTooltip /><MdPayment className="fa-Icon" size={20} /></span>
                                                        <span className="detailsicon" data-tip="View Change Orders" onClick={() => this.showChangeOrders(co)}><ReactTooltip /><MdImportExport className="fa-Icon" size={20} /></span>                                                   
                                                        <span className="detailsicon" data-tip="View Contract Details" onClick={() => this.showContractDetails(co)}><ReactTooltip /><MdDescription className="fa-Icon" size={20} /></span>
                                                        <span className="detailsicon" data-tip="View Contract Management Details" onClick={() => this.showCMDetails(co)}><ReactTooltip /><MdList className="fa-Icon" size={20} /></span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card-right">
                                            {(!co.contractType.includes('Construction/') && !co.contractType.includes('Force Account/')) ? <div className="categories aeCategories">Parent Contract Information </div> :
                                            <div className="categories aeCategories">Timeline</div> }
                                                <div className="row card-details">
                                                    <div className="col l3 m3 s6">
                                                        <h6>Contract Start</h6>
                                                        <p>{getDateValue(co.origContractStartDate)}</p>
                                                    </div>
                                                    <div className="col l3 m3 s6">
                                                        <h6>Contract End</h6>
                                                        <p>{getDateValue(co.origContractCompleteDate)}</p>
                                                    </div>
                                                    <div className="col l3 m3 s6">
                                                        <h6>Registration Date</h6>
                                                        <p>{getDateValue(co.cntrctRegDt)}</p>
                                                    </div>
                                                    <div className="col l3 m3 s6">
                                                        <h6>Contr. Award Date</h6>
                                                        <p>{getDateValue(co.awardDate)}</p>
                                                    </div>

                                                    <div className="col l3 m3 s6">
                                                        <h6>Proposed Bid Date</h6>
                                                        <p>{getDateValue(co.projectedBidDt)}</p>
                                                    </div>
                                                    <div className="col l3 m3 s6">
                                                        <h6>Original Bid Date</h6>
                                                        <p>{getDateValue(co.cnstrProcOrigBidDt)}</p>
                                                    </div>
                                                    <div className="col l3 m3 s6">
                                                        <h6>To Comptroller</h6>
                                                        <p>{getDateValue(co.cntrctDttoCmptr)}</p>
                                                    </div>
                                                    {(!co.contractType.includes('Construction/') && !co.contractType.includes('Force Account/')) ? null :
                                                      <div className="col l3 m3 s6">
                                                        <h6>NTP Date</h6>
                                                        <p>{getDateValue(co.noticeToProceedDate)}</p>
                                                    </div>}

                                                    {(co.contractType.includes('Professional') && co.contractType.includes('Requirements'))
                                                        ? <div className="col s11 m12 l5 offset-l7">
                                                            <button className="btn-save float-right" onClick={() => this.showTaskOrders(co)}>View TO/Initiate STO</button>
                                                        </div>
                                                        : null}
                                                   
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>)}           
                    </div>

                    : <div className="noData">No contracts are found.</div>}
            </div>
		);
	}
}

ProjectContractDetailsNew.propTypes = {
	projectId: PropTypes.string.isRequired,
	contracts: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
    console.log( state.additionalProjectsStore.allCntractData);
	return {
		contracts: state.additionalProjectsStore.allCntractData,
		projectId: ownProps.projectId,
	};
}

export default connect(mapStateToProps, { fetchProjectContractDetails })(ProjectContractDetailsNew);